import { useLocalSearchParams } from 'expo-router';
import { GroupDetailView } from '../../../../components/worldcup/GroupDetailView/GroupDetailView';

export default function WorldCupGroupDetailRoute() {
  const { groupId } = useLocalSearchParams<{ groupId: string }>();
  return <GroupDetailView groupId={groupId ?? ''} />;
}
